<template>
  <router-view v-if="showReloadIndex" :key="fullPath"/>
</template>

<script  setup>
import {computed, nextTick, onMounted, onUnmounted, provide, ref} from "vue";
import {remoteExposesStore} from "@/utils/remoteExpose";
import {getUrlQuery} from "@/utils/url";
import Cookies from 'js-cookie'
import {useRoute} from "vue-router/composables";

const showReloadIndex = ref(true)
function reload() {
  showReloadIndex.value = false;
  nextTick(function () {
    showReloadIndex.value = true;
  });
}

provide('reload', reload)

const router = useRoute()
const urlQuery = getUrlQuery();

// 从url中获取cookie-token,并存储到cookie中
const cookieToken = urlQuery['cookie-token'];
window.token = urlQuery.token;
if (cookieToken) {
  Cookies.set('token', cookieToken, {sameSite: 'None', secure: true});
}


const fullPath = computed(() => {
  return router.fullPath
})


const loaded = ref(false);
const params = ref({});


// 监听基座下发的数据变化
window.addEventListener("message", (e) => {
  if (e.data._action == "invoke") {
    invoke(e.data)
  } else if (e.data._action == "init") {
    //params.value = data.params;
  }
})


const iframeId = urlQuery._iframe

function invoke(data) {
  const method = remoteExposesStore[`${data.methodName}`];
  let ret = null;
  if (method) {
    if (data.params == null) {
      ret = method();
    } else {
      console.log('mic接收的数据参数', data)
      const params = JSON.parse(data.params);
      ret = method(params);
    }

  }
  // todo返回值
}

function tellIframeParentWindowHeight() {
  const bodyHeight = document.querySelector("#micro-service-app").scrollHeight;
  window.parent.postMessage({
    _domain: 'remote-component',
    _action: "sizing",
    data: {height: bodyHeight},
    iframeId
  }, '*');
}

let timer = null
//绑定到window,方便调试
window.invoke = invoke;
onMounted(() => {


  params.value = {
    ...urlQuery
  }
  loaded.value = true
  //timer = setInterval(tellIframeParentWindowHeight, 100)
});

onUnmounted(() => {
  // clearInterval(timer)
  // timer = null
})

window.onunload = () => {
  loaded.value = false
};
</script>
<style>
.qiangzhi,.chart-item{
    page-break-before: always;
}
.qiangzhi{
  display: block!important;
}
</style>
